$(document).ready(function () {

    $("#QuickLookModal .SmallProductImages img").live("click", function () {
        var ImageIndex = $(this).index();
        $("#QuickLookModal .ProductDetailImages ul li").each(function () {
            if ($(this).index() == ImageIndex) {
                $(this).removeClass("gizli");
                $(this).find("a img").attr("src", $(this).find("a img").data("src"));
            }
            else {
                $(this).addClass("gizli");
            }


        });
        $("#QuickLookModal .SmallProductImages img").each(function () {
            if ($(this).index() == ImageIndex) {
                $(this).addClass("Selected");
            } else {
                $(this).removeClass("Selected");
            }


        });


    });


    function setBasketContainerHeight() {
        var ContentHeight = $(".SepetProducts").height() - 360;
        $(".BasketCenterContent").height(ContentHeight);
        $(".BasketCenterContent").css("max-height", ContentHeight);

        $(window).resize(function () {
            var ContentHeight = $(".SepetProducts").height() - 360;
            $(".BasketCenterContent").height(ContentHeight);
            $(".BasketCenterContent").css("max-height", ContentHeight);
        });

    }

    $("#QuickLookModal .Sizes .outer").live("hover", function () {
        $("#QuickLookModal .Sizes .outer .PdHint-content .NotifyWhen").remove();
    });


    $('#QuickLookModal .SizeOptions a:not(.NotifyWhen)').live("click", function () {

        $(this).parents(".Sizes").find(".Name").html($(this).attr("data-name"));
        $(this).parents(".Sizes").find("#SizeID").val($(this).attr("data-id"));
        $(this).parents(".Sizes").find("#SizeID").val($(this).attr("data-id"));

        $(this).parent().find("a").removeClass("active");
        $(this).addClass("active");



        if ($(".NewPD").length > 0) {

            $(".SizeOptions, .SizeAndAmount span.ChooseTitle").addClass("passed");

            $(".Colors span.ChooseTitle").removeClass("current");
            $(".Colors span.ChooseTitle").addClass("passed");

            $(".Sizes span.ChooseTitle").removeClass("current");
            $(".Sizes span.ChooseTitle").addClass("passed");

            $(".SizeAndAmount  > span.ChooseTitle").removeClass("current");
            $(".SizeAndAmount  > span.ChooseTitle").addClass("passed");

            $(".AmountOptions  span.ChooseTitle").removeClass("passed");
            $(".AmountOptions  span.ChooseTitle").addClass("current");


            var TrigAddBasket = false;

            if ($(".SizeOptions.PleaseSelect").length == 1) {
                TrigAddBasket = true;
            }


            $(".AmountOptions").addClass("open");

            $(".AddToBasket button").removeClass("NotSelected");


            if ($(".AutoTextRep").length > 0 && $(".AddToBasket button").attr("data-first") != undefined && $(".AddToBasket button").attr("data-first").length > 0 && $(".EsPD").length <= 0) {

                $(".AddToBasket button").text($(".AddToBasket button").attr("data-first"));
            }

            $(".SizeOptions").removeClass("PleaseSelect");
            $("#PrdBlackBg").hide();

            if (TrigAddBasket) {
                $(".AddToBasket #Basket").click();
            }

        }

        if ($(".LastProducts").length > 0) {

            var params = "ProductID=" + $("#ProductID").val() + "&ColorID=" + $("#ColorID").val() + "&SizeID=" + $("#SizeID").val();

            $.ajax({
                type: "GET",
                url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/StokWarn",
                data: params,
                success: function (data) {

                    if (data != "0" && data != 0) {

                        var prdCls = "More";

                        $(".LastProducts").removeClass("One");
                        $(".LastProducts").removeClass("Two");
                        $(".LastProducts").removeClass("More");
                        $(".LastProducts").removeClass("Limited");

                        $(".LastX").html(data);
                        $(".LastPrdHint").html($(".LastPrdHint").attr("data-more"));

                        if (data.length > 1) {
                            $(".LastX").css("margin-left", "2px");
                        }
                        else {
                            $(".LastX").css("margin-left", "4px");
                        }

                        switch (data) {

                            case "1": prdCls = "One"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-one")); break;
                            case "2": prdCls = "Two"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-twotree")); break;
                            case "3": prdCls = "Two"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-twotree")); break;
                            case "": prdCls = "gizli"; $(".LastPrdHint").html(""); break;
                            case "4": prdCls = "Limited"; break;

                        }

                        $(".LastProducts").addClass(prdCls);
                        $(".LastProducts").show();

                    }
                }

            });

        }


    });


    $("#QuickLookModal .ProductDetailImages .QuickRight").live("click", function (e) {

        $CurrentObject = $("#QuickLookModal .ProductDetailImages ul li.ImgArea.Selected");


        if ($CurrentObject.index() == ($("#QuickLookModal .ProductDetailImages ul li.ImgArea").size() - 1)) {
            $("#QuickLookModal .ProductDetailImages ul li.ImgArea").addClass("gizli");
            $("#QuickLookModal .ProductDetailImages ul li.ImgArea").removeClass("Selected");
            $("#QuickLookModal .ProductDetailImages ul li.ImgArea").first().addClass("Selected");
            $("#QuickLookModal .ProductDetailImages ul li.ImgArea").first().removeClass("gizli");

        } else {
            $CurrentObject.addClass("gizli");
            $CurrentObject.removeClass("Selected");
            $CurrentObject.next().removeClass("gizli");
            $CurrentObject.next().addClass("Selected");
        }

    });


    $("#QuickLookModal .ProductDetailImages .QuickLeft").live("click", function (e) {


        $CurrentObject = $("#QuickLookModal .ProductDetailImages ul li.ImgArea.Selected");


        if ($CurrentObject.index() == 0) {
            $("#QuickLookModal .ProductDetailImages ul li.ImgArea").addClass("gizli");
            $("#QuickLookModal .ProductDetailImages ul li.ImgArea").removeClass("Selected");
            $("#QuickLookModal .ProductDetailImages ul li.ImgArea").last().addClass("Selected");
            $("#QuickLookModal .ProductDetailImages ul li.ImgArea").last().removeClass("gizli");

        } else {
            $CurrentObject.addClass("gizli");
            $CurrentObject.removeClass("Selected");
            $CurrentObject.prev().removeClass("gizli");
            $CurrentObject.prev().addClass("Selected");
        }

    });


    if ($("#QuickLookModal .SizeOptions .ONE.SIZE").length > 0) {

        $(".SizeOptions .ONE.SIZE").trigger("click");
        //$(".SizeAndAmount").hide();
    }



    $("#QuickLookModal .AddToBasket #Basket").live("click", function (e) {


        var SizeID = $("#QuickLookModal .Sizes .SizeAndAmount > input[name=SizeID]").val();
        var ColorID = $("#QuickLookModal .Colors > input[name=ColorID]").val();


        var ProductID = $("#ProductID").val();

        var Amount = $("#Amount").val();
        var LangID = $("#LangID").val();
        var BedenSec = $('#BedenSec').val();
        var RenkSec = $('#RenkSec').val();
        var UrunYok = $('#UrunYok').val();

        $basketButton = $(this);

        if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "") {
            
            var NormalText = $basketButton.text();
            var AddingText = $basketButton.attr("data-adding");
            $basketButton.text(AddingText);

            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToCart",
                data: 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID,
                dataType: 'json',
                async: true,
                success: function (dt) {
                    if ($(window).width() < 768) {
                        $basketButton.html("<div class='BasketIcon hidden-md hidden-lg'></div>" + NormalText);
                    }
                    else {
                        $basketButton.text(NormalText);
                    }

                    //alert(dt.Sonuc + dt.IslemSonucAciklama);
                    $("#GeneralModal .modal-header h3").html(dt.IslemSonucAciklama);

                    if (dt.Sonuc == true) {
                        $Modal = $("div#QuickLookModal");

                        if ($Modal.length > 0) {
                            $Modal.modal("hide");
                        }

                        if (dt.Deger8 !== null && dt.Deger8 !== undefined && dt.Deger8 !== '') {

                            var _customModels = dt.Deger8.split("<InsiderObjectBeginning>");

                            if (_customModels !== null) {

                                //#region Related Datalayer Add To Basket Operation
                                if (window.dataLayer !== null && window.dataLayer !== undefined) {
                                    var _dataLayerObject = _customModels[0];

                                    if (_dataLayerObject !== null && _dataLayerObject !== undefined && _dataLayerObject !== '') {
                                        window.dataLayer.push(JSON.parse(_dataLayerObject));
                                    }
                                }
                                //#endregion

                                //#region Insider Object Add To Basket Operation
                                //if (window.insider_object !== null && window.insider_object !== undefined) {
                                //    var _insiderObject = _customModels[1];

                                //    if (_insiderObject !== null && _insiderObject !== undefined && _insiderObject !== '') {
                                //        window.insider_object = JSON.parse(_insiderObject);
                                //    }
                                //}
                                updateInsiderObjectIfChanged(_customModels[1]);
                                //#endregion
                            }
                        }

                        $.ajax({
                            type: 'get',
                            url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                            data: "",
                            async: true,
                            contentType: "application/json; charset=utf-8",
                            dataType: 'text',
                            success: function (dt) {
                                $("#UserAndBasket").html(dt);

                                $('html, body').animate({ scrollTop: 0 }, 'slow');

                                $(".RightBasket").addClass("active");
                                $("body").addClass("BasketDropped");

                                $(".SepetProducts").hide();
                                $(".SepetButton a").trigger("click");
                                //setBasketContainerHeight();
                                $(".AjaxLoaderDiv").hide();
                            }
                        });
                        
                        if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

                            var basketParams = GetSwPageParams();

                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ActionType", "SepeteEkleme");
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ProductID", ProductID);
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ColorID", ColorID);
                            basketParams += "&CatalogID=" + $("#CurCatalogID").val();

                            AddSwAction(basketParams);
                        }

                        if (UseTagManager) {
                            SendCartAddEvent('');
                        }
                    }
                    else {
                        alert(dt.IslemSonucAciklama);
                    }
                }
            });
        }
        else {
            if (SizeID == undefined || SizeID == "") {
                $("#PrdBlackBg").show();
                $(".SizeOptions.open").addClass("PleaseSelect");
                // $("body").addClass("BackDropped");

                $('html, body').animate({
                    scrollTop: $(".SizeOptions").offset().top - 150
                }, 500);
                
                if ($(".AutoTextRep").length > 0) {

                    $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
                    $(".AddToBasket button").text($('#BedenSec').val());

                    $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }
            }

            if (ColorID == undefined || ColorID == "") {

                alert(RenkSec);

                $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
                $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());

                if ($(".AutoTextRep").length > 0) {
                    $(".AddToBasket button").text($('#BedenSec').val());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }

            }

            if (ProductID == undefined || ProductID == "") alert(UrunYok);


        }

        e.preventDefault();
        return false;

    });



    $("#QuickLookModal .ProductContent .Colors a").live("click", function () {

        var ProductID = $(this).data("productid");
        var ColorID = $(this).data("id");

        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/QuickLook",
            data: 'ProductID=' + ProductID + "&ColorID=" + ColorID,
            success: function (dt) {

                $("#QuickLookModal .modal-body").html(dt);
                $("#QuickLookModal .Colors a").each(function () {
                    if ($("#QuickLookModal .Colors > input[name=ColorID]").val() == $(this).data("id")) {
                        $("#QuickLookModal .Colors a").removeClass("active");
                        $(this).addClass("active");
                    }
                });

            }

        });
    });




});

